import { render } from "./ListaForm.vue?vue&type=template&id=0a236be9"
import script from "./ListaForm.vue?vue&type=script&lang=js"
export * from "./ListaForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__